// extracted by mini-css-extract-plugin
export default {"button":"button-mExIj","default":"default-bxk+v","primary":"primary-yeySB"};